import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';

@Component({
  selector: 'ngx-density-controls',
  templateUrl: './density-controls.component.html',
  styleUrls: ['./density-controls.component.scss'],
})
export class DensityControlsComponent implements OnInit, OnChanges {
  @Input() public defaultDensity = 'loose';
  @Output() public densityChanged: EventEmitter<string> = new EventEmitter<string>();

  public density = 'loose';

  constructor() {
    this.density = this.defaultDensity;
  }

  public ngOnInit() {
  }

  public ngOnChanges(changes: SimpleChanges) {
    this.onDefaultDensityChanged(changes['defaultDensity']);
  }

  private onDefaultDensityChanged(change: SimpleChange) {
    if (!change || !change.currentValue) {
      return;
    }

    this.density = change.currentValue;
    this.densityChanged.emit(change.currentValue);
  }

  public setDensity(event, density: string) {
    if (event) {
      event.preventDefault();
    }

    this.density = density;
    this.densityChanged.emit(density);
  }
}
